const fonts = {
  heading: '"DPD Pluto Sans", sans-serif',
  body: '"DPD Pluto Sans", sans-serif',
};
export default fonts;
